import { Component, OnInit } from '@angular/core';
import { Track } from 'ngx-audio-player';

@Component({
  selector: 'app-music',
  templateUrl: './music.component.html',
  styleUrls: ['./music.component.css']
})
export class MusicComponent implements OnInit {

  constructor() { }

// Material Style Advance Audio Player Playlist
/* msaapPlaylist: Track[] = [
  {
    title: 'USM - Allez les jeunes',
    link: 'https://web019.mp3-youtube.download/tmp/20200715162911_a6cb3573-d9a9-41e5-9e49-b008940df808.mp3/usm-allez-les-jeunes.mp3?md5=xAsKn0pZ0NDmT9UJ_MgagQ&expires=1594830572'
  },
  {
    title: 'قصة رجال ',
    link: 'https://web039.mp3-youtube.download/tmp/20200715163248_e0da1952-f7c7-4756-880c-d0e0669157a9.mp3/ks-rgal-ultras-monastir.mp3?md5=R0tDsy8HFiuoUZIOu3tNpQ&expires=1594830804'
  },
  {
    title : 'Fi 5aterha',
    link : 'https://web042.mp3-youtube.download/tmp/20200715164154_fab6e267-306c-4acd-b9ad-d82be231169b.mp3/fy-khatrha-fi-5aterha.mp3?md5=FlTGESImHt7nevp2p11MNg&expires=1594831337'
  },
  {
    title:'USM - kil aada jina',
    link : 'https://web002.mp3-youtube.download/tmp/20200715165613_836e05f6-cd38-4a9d-bf9b-baefc6bc9d14.mp3/usm-kil-aada-jina.mp3?md5=q296yWzMrG5h9E37nA0MBQ&expires=1594832211'
  },
  {
    title : 'USM - Zarka ti quiero  ',
    link : 'https://web002.mp3-youtube.download/tmp/20200715165754_25179359-6a58-41ef-a9f5-c8aae4affff3.mp3/usm-zarka-ti-quiero.mp3?md5=IcRu_34hsl6b1eKDiheDFA&expires=1594832295'
  },
  {
    title:'USM - Zarka enti hyét ',
    link : 'https://web002.mp3-youtube.download/tmp/20200715170044_ac4d20b3-7419-4539-8e42-8b77df7ec9e7.mp3/usm-zarka-enti-hyet.mp3?md5=mWHV28Ctb8AKABczRvxuDg&expires=1594832472'
  },  {
    title:'USM - Vamos la gloria',
    link : 'https://web009.mp3-youtube.download/tmp/20200715170912_6fc2a66d-4ac0-4a24-bd2a-a4c6d10d0153.mp3/usm-vamos-la-gloria.mp3?md5=0vPdYQ0d_D9PIxMyDxny1Q&expires=1594832973'
  },  {
    title:'USM - Rouho kol boldén',
    link : 'https://web009.mp3-youtube.download/tmp/20200715171040_47355488-320b-45a0-a562-6a57c532cc78.mp3/usm-rouho-kol-bolden.mp3?md5=5ZlHQsEkQsIJovh2W1FJIg&expires=1594833063'
  },  {
    title:'USM - Slehna fi idina  ',
    link : 'https://web009.mp3-youtube.download/tmp/20200715171140_7202bcf3-5530-4912-8da8-19558485ac7a.mp3/usm-slehna-fi-idina.mp3?md5=2mCjYnEtxIfaYjDGsMYBwQ&expires=1594833134'
  },  {
    title:'USM - Louled diro el courage',
    link : 'https://web009.mp3-youtube.download/tmp/20200715171401_fba79cf1-ed44-44cf-99ba-230e9d1935ba.mp3/usm-louled-diro-el-courage.mp3?md5=umgXIdeGeAwcRBQZuzO8IQ&expires=1594833264'
  }
]; */
  ngOnInit(): void {}

}
